/**
 * ============================================================================
 * TaskFlow ERP
 * Module : Campaign Management
 * Feature: Prospect Import
 *
 * File:
 * src/modules/campaign/prospectImport/components/importWorkspace/drawers/ViewDrawer.jsx
 *
 * Description:
 * Read-only drawer for viewing imported prospect details.
 *
 * Responsibilities
 * ----------------
 * • Display imported prospect information
 * • Display validation results
 * • Display remarks
 * • Read-only
 *
 * No business logic.
 * ============================================================================
 */

import React from "react";

import {
    Offcanvas,
    Row,
    Col,
    Card,
    Button,
    Badge
} from "react-bootstrap";

export default function ViewDrawer({

    show,

    config,

    state,

    actions

}) {

    // ==========================================================
    // STATE
    // ==========================================================

    const {

        selectedRecord

    } = state;

    // ==========================================================
    // ACTIONS
    // ==========================================================

    const {

        closeViewDrawer

    } = actions;

    if (!selectedRecord) {

        return null;

    }

    return (

        <Offcanvas

            show={show}

            onHide={closeViewDrawer}

            placement="end"

            backdrop={true}

            scroll={false}

            style={{ width: "700px" }}

        >

            {/* ====================================================== */}
            {/* HEADER */}
            {/* ====================================================== */}

            <Offcanvas.Header closeButton>

                <Offcanvas.Title>

                    <i className="fas fa-eye me-2 text-primary"></i>

                    View Imported Prospect

                </Offcanvas.Title>

            </Offcanvas.Header>

            <Offcanvas.Body>

                {/* ================================================== */}
                {/* GENERAL INFORMATION */}
                {/* ================================================== */}

                <Card className="mb-4">

                    <Card.Header>

                        <strong>

                            General Information

                        </strong>

                    </Card.Header>

                    <Card.Body>

                        <Row className="mb-3">

                            <Col md={4}>

                                <strong>

                                    Prospect Name

                                </strong>

                            </Col>

                            <Col md={8}>

                                {selectedRecord.name}

                            </Col>

                        </Row>

                        <Row className="mb-3">

                            <Col md={4}>

                                <strong>

                                    External ID

                                </strong>

                            </Col>

                            <Col md={8}>

                                {selectedRecord.external_id}

                            </Col>

                        </Row>

                        <Row className="mb-3">

                            <Col md={4}>

                                <strong>

                                    Contacts

                                </strong>

                            </Col>

                            <Col md={8}>

                                {selectedRecord.contacts}

                            </Col>

                        </Row>

                        <Row>

                            <Col md={4}>

                                <strong>

                                    Status

                                </strong>

                            </Col>

                            <Col md={8}>
                                                            <Badge

                                    bg={

                                        selectedRecord.status === "Verified"

                                            ? "success"

                                            : selectedRecord.status === "Duplicate"

                                            ? "warning"

                                            : selectedRecord.status === "Warning"

                                            ? "info"

                                            : "danger"

                                    }

                                    text={
                                        selectedRecord.status === "Duplicate"
                                            ? "dark"
                                            : undefined
                                    }

                                >

                                    {selectedRecord.status}

                                </Badge>

                            </Col>

                        </Row>

                    </Card.Body>

                </Card>

                {/* ================================================== */}
                {/* VALIDATION INFORMATION */}
                {/* ================================================== */}

                <Card className="mb-4">

                    <Card.Header>

                        <strong>

                            Validation Information

                        </strong>

                    </Card.Header>

                    <Card.Body>

                        <Row className="mb-3">

                            <Col md={5}>

                                <strong>

                                    Validation Status

                                </strong>

                            </Col>

                            <Col md={7}>

                                <span className="text-success">

                                    <i className="fas fa-check-circle me-2"></i>

                                    Verified

                                </span>

                            </Col>

                        </Row>

                        <Row className="mb-3">

                            <Col md={5}>

                                <strong>

                                    Duplicate Check

                                </strong>

                            </Col>

                            <Col md={7}>

                                {

                                    selectedRecord.status === "Duplicate"

                                        ? (

                                            <span className="text-warning">

                                                <i className="fas fa-exclamation-circle me-2"></i>

                                                Duplicate Found

                                            </span>

                                        )

                                        : (

                                            <span className="text-success">

                                                <i className="fas fa-check-circle me-2"></i>

                                                Passed

                                            </span>

                                        )

                                }

                            </Col>

                        </Row>

                        <Row className="mb-3">

                            <Col md={5}>

                                <strong>

                                    Business Validation

                                </strong>

                            </Col>

                            <Col md={7}>

                                {

                                    selectedRecord.status === "Invalid"

                                        ? (

                                            <span className="text-danger">

                                                <i className="fas fa-times-circle me-2"></i>

                                                Failed

                                            </span>

                                        )

                                        : (

                                            <span className="text-success">

                                                <i className="fas fa-check-circle me-2"></i>

                                                Passed

                                            </span>

                                        )

                                }

                            </Col>

                        </Row>

                        <Row>

                            <Col md={5}>

                                <strong>

                                    Email Validation

                                </strong>

                            </Col>

                            <Col md={7}>

                                <span className="text-success">

                                    <i className="fas fa-check-circle me-2"></i>

                                    Passed

                                </span>

                            </Col>

                        </Row>

                    </Card.Body>

                </Card>

                {/* ================================================== */}
                {/* REMARKS */}
                {/* ================================================== */}

                <Card>

                    <Card.Header>

                        <strong>

                            Remarks

                        </strong>

                    </Card.Header>

                    <Card.Body>

                        {

                            selectedRecord.remarks

                                ? (

                                    <div>

                                        {selectedRecord.remarks}

                                    </div>

                                )

                                : (

                                    <span className="text-muted">

                                        No validation issues found.

                                    </span>

                                )

                        }

                    </Card.Body>

                </Card>
                                {/* ====================================================== */}
                {/* FOOTER */}
                {/* ====================================================== */}

                <div className="d-flex justify-content-end mt-4">

                    <Button

                        variant="secondary"

                        onClick={closeViewDrawer}

                    >

                        <i className="fas fa-times me-2"></i>

                        Close

                    </Button>

                </div>

            </Offcanvas.Body>

        </Offcanvas>

    );

}